module.exports = __webpack_public_path__ + "static/media/arrow_up.75e11dd3.svg";